import script from "./addOrUpdateEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./addOrUpdateEmail.vue?vue&type=script&setup=true&lang=ts"

import "./addOrUpdateEmail.vue?vue&type=style&index=0&id=3a57279a&lang=scss"

const __exports__ = script;

export default __exports__